export default {"src":"/_next/static/media/legalDoc_40.91350b10.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};